// extracted by mini-css-extract-plugin
export var divider = "_p1-0";
export var systemMessage = "_p1-1";
export var systemMessageWrapper = "_p1-2";